import { useSelector } from 'react-redux';
import MetaData from '../Layouts/MetaData';
import MinCategory from '../Layouts/MinCategory';
import Sidebar from '../User/Sidebar';
import Product from './Product';
import {
    Container,
    Typography,
    Grid,
    Paper,
    useTheme,
    Grow,
} from '@mui/material';

const Wishlist = () => {
    const { wishlistItems } = useSelector((state) => state.wishlist);
    const theme = useTheme();

    return (
        <>
            <MetaData title="Wishlist - AmritLok" />
            <MinCategory />
            <Container
                maxWidth="xl"
                sx={{
                    mt: { xs: 2, sm: 4 },
                    mb: 7,
                    bgcolor: 'background.default',
                    py: 4,
                }}
            >
                <Grid container spacing={4}>
                    <Grid item xs={12} md={3}>
                        <Sidebar activeTab={'wishlist'} />
                    </Grid>
                    <Grid item xs={12} md={9}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: { xs: 2, sm: 4 },
                                borderRadius: 2,
                                bgcolor: 'background.paper',
                            }}
                        >
                            <Typography
                                variant="h5"
                                component="h1"
                                sx={{
                                    mb: 4,
                                    borderBottom: `2px solid ${theme.palette.divider}`,
                                    pb: 2,
                                    color: 'text.primary',
                                }}
                            >
                                My Wishlist ({wishlistItems.length})
                            </Typography>

                            {wishlistItems.length === 0 ? (
                                <div className="flex items-center flex-col gap-2 m-6">
                                    <img
                                        draggable="false"
                                        className="object-contain"
                                        src="https://static-assets-web.flixcart.com/www/linchpin/fk-cp-zion/img/mywishlist-empty_39f7a5.png"
                                        alt="Empty Wishlist"
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{ mt: 4, color: 'text.secondary' }}
                                    >
                                        Your wishlist is empty!
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{ color: 'text.secondary' }}
                                    >
                                        Add items you love to your wishlist.
                                    </Typography>
                                </div>
                            ) : (
                                <Grow in={true}>
                                    <Grid container spacing={3}>
                                        {wishlistItems
                                            .map((item, index) => (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={6}
                                                    md={4}
                                                    key={index}
                                                >
                                                    <Product {...item} />
                                                </Grid>
                                            ))
                                            .reverse()}
                                    </Grid>
                                </Grow>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default Wishlist;